import store from "store"

const GKEY = "dnp.webovka"

export const storage = {
  set: (key: string, val: any) => {
    const data = store.get(GKEY) || {}
    data[key] = val
    store.set(GKEY, data)
  },

  get: (key: string): any | null => {
    const data = store.get(GKEY) || {}

    if (data[key]) {
      return data[key]
    }

    return null
  },

  delete: (key: string) => {
    const data = store.get(GKEY) || {}
    delete data[key]
    store.set(GKEY, data)
  }
}
